import { render, staticRenderFns } from "./MessageFormWrapper.vue?vue&type=template&id=4237c476&"
import script from "./MessageFormWrapper.vue?vue&type=script&lang=js&"
export * from "./MessageFormWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports